import { render, staticRenderFns } from "./flowAnalysis.vue?vue&type=template&id=28078de4&scoped=true"
import script from "./flowAnalysis.vue?vue&type=script&lang=js"
export * from "./flowAnalysis.vue?vue&type=script&lang=js"
import style0 from "./flowAnalysis.vue?vue&type=style&index=0&id=28078de4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28078de4",
  null
  
)

export default component.exports